export const COMPANY = {
  name: "ALL IN ONE SOURCING SPECIALISTS A.I.O",
  shortName: "All In One Sourcing Specialists A.I.O",
  abbreviation: "A.I.O",
  phone: "910-543-4489",
  phoneLink: "tel:+19105434489",
  email: "aoi@allinsource.com",
  emailLink: "mailto:aoi@allinsource.com",
  logoUrl: "/assets/logo-polished.png",
  logoFallback: "/assets/logo-original.jpeg",
};

export const STRIPE_LINKS = {
  portal_485: "https://buy.stripe.com/eVq3co5tx5CJh140iM5kk01",
  testdrive_995: "https://buy.stripe.com/aFafZaaNR7KR6mqaXq5kk00",
};

export const NAV_LINKS = [
  { label: "Home", to: "/", testId: "nav-home" },
  { label: "Activate Portal", to: "/activate", testId: "nav-activate" },
  { label: "Test Drive", to: "/test-drive", testId: "nav-testdrive" },
  { label: "Request Quote", to: "/contact", testId: "nav-contact" },
];
